var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { InlineChildren, InlineChildrenAlignment, InlineChildrenSize, StackChildren, } from '@doordash/design-language';
import Separator from '@doordash/component-separator';
var VERTICAL_SEPARATOR_HEIGHT = 40;
export var CalendarInfoContainerDesktop = styled(InlineChildren).attrs(function () { return ({
    alignItems: InlineChildrenAlignment.Center,
    size: InlineChildrenSize.None,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", "px;\n"], ["\n  height: ", "px;\n"])), VERTICAL_SEPARATOR_HEIGHT);
export var CalendarInfoContainerMobile = styled(StackChildren).attrs(function () { return ({
    size: StackChildren.Sizes.XxxSmall,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var VerticalSeparator = styled(Separator)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", "px;\n  height: 1px;\n  transform: rotate(90deg);\n  border-bottom: 0;\n"], ["\n  width: ", "px;\n  height: 1px;\n  transform: rotate(90deg);\n  border-bottom: 0;\n"])), VERTICAL_SEPARATOR_HEIGHT);
var templateObject_1, templateObject_2, templateObject_3;
